import React from 'react';
import { Hero } from '../components/Hero';
import { WhyUs } from '../components/WhyUs';
import { ByTheNumbers } from '../components/ByTheNumbers';
import { Services } from '../components/Services';
import { HowItWorks } from '../components/HowItWorks';
import { FAQ } from '../components/FAQ';
import { Reviews } from '../components/Reviews';
import { CtaBanner } from '../components/CtaBanner';
export function Home() {
  return <main data-id="element-2343">
      <div className="dark" data-id="element-2344">
        <Hero data-id="element-2345" />
      </div>
      <WhyUs data-id="element-2346" />
      <ByTheNumbers data-id="element-2347" />
      <Services data-id="element-2348" />
      <HowItWorks data-id="element-2349" />
      <FAQ data-id="element-2350" />
      <Reviews data-id="element-2351" />
      <CtaBanner data-id="element-2352" />
    </main>;
}